/**
 * 群组匹配管理 Hook
 */

import { useState } from "react";
import type { RecordData, ReceiverInfo, MatchingResult } from "../types";
import { matchRecordsToReceivers } from "../services/groupMatcher";

export function useGroupMatching() {
  const [matchingResult, setMatchingResult] = useState<MatchingResult | null>(
    null
  );
  const [isMatching, setIsMatching] = useState(false);

  /**
   * 执行匹配
   * @param records 表格记录列表
   * @param receivers 消息接收者列表
   * @param selectedFieldIds 用于匹配的字段 ID 列表
   */
  const performMatching = (
    records: RecordData[],
    receivers: ReceiverInfo[],
    selectedFieldIds: string[]
  ) => {
    setIsMatching(true);

    try {
      const result = matchRecordsToReceivers(
        records,
        receivers,
        selectedFieldIds
      );
      setMatchingResult(result);
    } catch (error) {
      console.error("匹配失败:", error);
      throw error;
    } finally {
      setIsMatching(false);
    }
  };

  /**
   * 清除匹配结果
   */
  const clearMatching = () => {
    setMatchingResult(null);
  };

  return {
    matchingResult,
    isMatching,
    performMatching,
    clearMatching,
  };
}
